<template>
  <div>
    <div class="modal-backdrop"></div>
    <div
      class="modal"
      :class="{ showOverlay: isRequestPendding || justSend || error }"
    >
      <div class="pull-right">
        <div class="btn-close" @click="close"></div>
      </div>
      <div class="heading">
        <h1>{{ artefact }} teilen</h1>
        <!--<ul class="tabsLabels">
            <li><a class="url" v-bind:class="{'active' : showTabs.url}" v-on:click="showURLTab()" >URL</a></li>
            <li><a class="email" v-bind:class="{'active' : showTabs.email}" v-on:click="showEmailTab()" >Email</a></li>
            <li><a class="mscons" v-bind:class="{'active' : showTabs.mscons}" v-on:click="showMSCONSTab()" >MSCONS</a></li>
            <li><a class="system" v-bind:class="{'active' : showTabs.system}" v-on:click="showSystemTab()" >System</a></li>
          </ul>-->
      </div>
      <div class="content">
        <!--<div class="tab tab-url" v-if="showTabs.url">
            <h3>Kopieren Sie die private URL und teilen Sie:</h3>
            <div class="input-group">
                <input placeholder="E-Mail-Adresse" value="https://codelos.io/1f23nx">
                <button class="default"><i class="far fa-copy"></i>&nbsp; Kopieren</button>
            </div>
          </div>-->
        <div class="tab tab-email" v-if="showTabs.email">
          <form @submit.prevent="sendEmail">
            <div class="input-group-wrapper">
              <div class="input-group">
                <b-form-tags
                  ref="emailTags"
                  input-id="tags-basic"
                  v-model="email.recipient"
                  separator=" ,;"
                  remove-on-delete
                  placeholder="E-Mail-Adresse"
                  name="emails"
                  required
                  :tag-validator="emailValidator"
                  @blur="blur"
                >
                </b-form-tags>
                <button class="senden">Senden</button>
              </div>
              <div class="invalid-feedback" v-show="isInvalidEmail">
                ungültige E-Mail-Adresse
              </div>
            </div>
            <textarea
              type="text"
              v-model="email.message"
              placeholder="Persönliche Notiz hinzufügen"
            ></textarea>
            <p>{{ description }}</p>
          </form>
        </div>
        <!--<div class="tab tab-mscons" v-if="showTabs.mscons">
            <div class="input-group">
                <input placeholder="E-Mail-Adresse">
                <button>Senden</button>
            </div>
            <textarea type="text" class="large" :value="value"></textarea>
            <button class="default"><i class="far fa-copy"></i>&nbsp; Kopieren</button>
            <button class="default"><i class="fas fa-arrow-down"></i>&nbsp; Download</button>
          </div>
          <div class="tab tab-system" v-if="showTabs.system">
            <div class="systems">
                <div class="systems-wrapper"> 
                    <div class="item-wrapper" v-for="s in systems" :key="s.id">
                        <div class="img-wrapper">
                          <img class="logo" v-bind:src="getImgUrl(s.img)">
                        </div>
                        <h2>{{s.name}}</h2>
                    </div>
                </div>
            </div>
          </div>-->
      </div>
      <div class="email-loader" v-if="isRequestPendding || justSend || error">
        <div class="content-wrap" v-if="isRequestPendding">
          <div class="spinner">
            <LoadingSpinner />
          </div>
          <div class="display-message">E-Mail wird versendet</div>
        </div>
        <div class="content-wrap" v-if="justSend">
          <div class="display-message">E-Mail wurde erfolgreich versendet</div>
          <div class="spinner">
            <button @click="onOKButtonClick()">OK</button>
          </div>
        </div>
        <div class="content-wrap" v-if="error">
          <div class="display-message">
            Beim versenden der E-Mail ist ein Fehler aufgetreten. Bitte
            versuchen Sie es erneut.
          </div>
          <div class="spinner">
            <button @click="onOKButtonClick()">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import AmplifyStore from '../../store/store';
export default {
  name: 'ModalShare',
  components: { LoadingSpinner },
  data() {
    return {
      email: {
        eMailEndPoint: process.env.VUE_APP_E_MAIL_API + '/send-email',
        //eMailEndPoint: 'http://127.0.0.1:1991/send-email',
        recipient: [],
        message: '',
      },
      justSend: false,
      error: false,
      isRequestPendding: false,
      showTabs: {
        url: false,
        email: true,
        mscons: false,
        system: false,
      },
      value:
        "UNA:+.? 'UNB+UNOC:3+9900137000009:500+9978033000001:500+190214:1134+1904500176347++TL'UNH+1+MSCONS:D:04B:UN:2.2h'BGM+7+19045001763471+9'DTM+137:201902141134:203'RFF+Z13:13008'NAD+MS+9900137000009::293'NAD+MR+9978033000001::293'UNS+D'NAD+DP'LOC+172+50789986584'DTM+163:201902110000?+01:303'DTM+164:201902140000?+01:303'LIN+1'PIA+5+1-1?:1.29.0:SRW'QTY+220:53.000'DTM+163:201902110000?+01:303'DTM+164:201902110015?+01:303'STS+8++Z86'QTY+220:52.000'DTM+163:201902110015?+01:303'DTM+164:201902110030?+01:303'STS+8++Z86'QTY+220:47.500'DTM+163:201902110030?+01:303'DTM+164:201902110045?+01:303'STS+8++Z86'QTY+220:48.000'DTM+163:201902110045?+01:303'DTM+164:201902110100?+01:303'STS+8++Z86'QTY+220:46.000'DTM+163:201902110100?+01:303'DTM+164:201902110115?+01:303'STS+8++Z86'QTY+220:38.500'DTM+163:201902110115?+01:303'DTM+164:201902110130?+01:303'STS+8++Z86'QTY+220:45.000'DTM+163:201902110130?+01:303'DTM+164:201902110145?+01:303'STS+8++Z86'QTY+220:47.000'DTM+163:201902110145?+01:303'DTM",
      systems: [
        {
          id: 2,
          name: 'Belvis EDM',
          img: './kisters-logo.png',
        },
        {
          id: 3,
          name: 'Enmacc',
          img: './enmacc-logo.png',
        },

        {
          id: 8,
          name: 'Soptim EDM',
          img: './soptim-logo.png',
        },
      ],
      isInvalidEmail: false,
    };
  },
  props: {
    artefact: String,
    attachment: Blob,
    description: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    //TODO: rewrite
    showURLTab() {
      this.showTabs.url = true;
      this.showTabs.email = false;
      this.showTabs.mscons = false;
      this.showTabs.system = false;
    },
    showEmailTab() {
      this.showTabs.url = false;
      this.showTabs.email = true;
      this.showTabs.mscons = false;
      this.showTabs.system = false;
    },
    showMSCONSTab() {
      this.showTabs.url = false;
      this.showTabs.email = false;
      this.showTabs.mscons = true;
      this.showTabs.system = false;
    },
    showSystemTab() {
      this.showTabs.url = false;
      this.showTabs.email = false;
      this.showTabs.mscons = false;
      this.showTabs.system = true;
    },
    getImgUrl: function (img) {
      var images = require.context('../../assets/img/', false, /\.png$/);
      return images(img);
    },
    emailValidator(tag) {
      const pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
      if (pattern.test(tag)) this.isInvalidEmail = false;
      else this.isInvalidEmail = true;
      return pattern.test(tag);
    },

    sendEmail() {
      this.isRequestPendding = true;
      // API headers
      const myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken + ''
      );

      // API params
      const formData = new FormData();
      formData.append('receiver', this.email.recipient.join(','));
      formData.append('subject', this.artefact);
      formData.append('attachment', this.attachment, this.artefact);
      formData.append(
        'template_url',
        'https://codelos-public-media.s3.eu-central-1.amazonaws.com/assets/templates/share-codelos.html'
      );
      formData.append('search_value', '%firstname%');
      formData.append('search_value', '%lastname%');
      formData.append('search_value', '%note%');
      formData.append('new_value', this.user.attributes.name);
      formData.append('new_value', this.user.attributes.family_name);
      formData.append('new_value', this.email.message);

      // call api
      fetch(this.email.eMailEndPoint, {
        method: 'POST',
        headers: myHeaders,
        body: formData,
      }).then((response) => {
        if (response.ok) {
          this.isRequestPendding = false;
          this.justSend = true;
        } else {
          this.isRequestPendding = false;
          this.error = true;
        }
      });
    },
    onOKButtonClick() {
      if (this.justSend) this.justSend = false;
      if (this.error) this.error = false;
    },
    blur(e) {
      if (
        this.email.recipient.length == 0 &&
        this.emailValidator(e.target.value)
      ) {
        this.$refs.emailTags.addTag();
      } else {
        e.target.value = '';
        this.$refs.emailTags.newTag = '';
      }
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  computed: {
    user() {
      return AmplifyStore.state.user;
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 50%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 65%;
}

.heading {
  padding: 50px 0px 40px;
  text-align: center;
}

.content {
  padding: 20px 50px;
  background-color: rgb(249, 249, 251);
  width: 100%;
  height: calc(100% - 137px);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #eaecf1;
  background: #f9f9fb;
}

h1 {
  text-align: center;
  font-size: 32px;
  color: #2b2d34;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.input-group button.senden {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  font-size: 0.9375rem;
  margin-left: 40px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.input-group-wrapper {
  margin-bottom: 25px;
}
.input-group button.senden:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 76%;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 25px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 160px;
  width: 100%;
  overflow: hidden;
}

textarea::placeholder {
  color: rgb(195, 195, 196);
}

.input-group {
  width: 100%;
}

/* Style that has no refference*/
.imput-group > input {
  width: 70%;
}

.pull-right {
  float: right;
  margin: 15px 8px 0 0;
}

/* Style that has no refference*/
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}
/* Style that has no refference*/
/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .url {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.message {
  font-size: 14px;
  font-family: sans-serif;
  margin-top: 7px;
  padding-left: 4px;
  font-weight: 600;
}

.message.success {
  color: #6cbd7c;
}

.message.error {
  color: rgb(255, 51, 102);
}

.email-loader {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
}
.display-message {
  color: #fff;
}
::v-deep .email-loader .progress-icon {
  margin-top: 0;
  width: 35px;
  height: 35px;
}
::v-deep .loading .progress-icon {
  transform: translateY(0);
  position: unset;
}

::v-deep .email-loader .progress-icon:after {
  width: 30px;
  height: 30px;
  border-color: #fff transparent;
}

.email-loader .spinner {
  min-height: 30px;
  text-align: center;
}
.modal.no-scroll {
  overflow: hidden;
}
.email-loader button {
  margin-top: 20px;
  height: 30px;
  text-transform: uppercase;
  background: rgb(255, 51, 102);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.125px;
  border-radius: 4px;
  padding: 3px 10px;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  border-width: 0;
  border-style: none;
  min-width: 100px;
}
.modal.showOverlay {
  overflow: hidden;
}

.b-form-tags {
  max-height: 60px;
  overflow: auto;
}
.b-form-tags.focus,
.b-form-tags:focus {
  border: 2px solid #000;
  box-shadow: none;
}
::v-deep .b-form-tags .b-form-tags-list button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}
::v-deep .b-form-tags.form-control {
  background-color: transparent;
}
::v-deep .b-form-tags .b-form-tags-button {
  display: none;
}
::v-deep .b-form-tags .b-form-tags-list .close {
  font-weight: 700;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
::v-deep .b-form-tags .b-form-tags-list .badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
::v-deep .b-form-tags .invalid-feedback {
  display: none !important;
}
</style>
